var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMute = function SvgMute(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#07818C",
    fillRule: "evenodd",
    d: "M29.245 3.01a3 3 0 0 0-4.366-.131L17.757 10H9a3 3 0 0 0-3 3v11c0 .842.347 1.603.905 2.148L9 23.978V13h10l5-5 3-3v.335zM14.539 24H19l5 4.375L27 31V11.094l3-3.107V31a3 3 0 0 1-4.975 2.258L17.873 27h-6.23z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#07818C",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M33 2 5 31"
  })));
};
export default SvgMute;